var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  "+_vm._s(_vm.label)+"\n  "),_c('flat-pickr',{attrs:{"config":_vm.configdateTimePicker,"placeholder":"Date/Time"},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }